export default "__VITE_ASSET__77a4f7f2__"